import * as React from "react";

import { Filter } from "constants/filters";
import { IAgent } from "store/entities/agents";
import { ITag } from "store/entities/tags";
import { Subtract } from "utils/interface";

import { IAvailableFilter } from "./interfaces";

interface ITargetComponentProps {
  agents?: IAgent[];
  tags?: ITag[];
}

interface IAddedProps {
  availableFilters: IAvailableFilter[];
  agents?: IAgent[];
  tags?: ITag[];
}

const filterExists = (filters: IAvailableFilter[], filter: Filter): boolean =>
  filters.some((availableFilter: IAvailableFilter) => availableFilter.filter === filter);

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function withFiltersData<P extends ITargetComponentProps>(Component: React.ComponentType<P>) {
  type EnhancedComponentProps = Subtract<P, ITargetComponentProps> & IAddedProps;
  const EnhancedComponent: React.FC<EnhancedComponentProps> = (props: EnhancedComponentProps) => {
    const injectedProps: ITargetComponentProps = {};

    if (filterExists(props.availableFilters, Filter.Agent) || filterExists(props.availableFilters, Filter.Followers)) {
      injectedProps.agents = props.agents;
    }

    if (filterExists(props.availableFilters, Filter.Tag)) {
      injectedProps.tags = props.tags;
    }

    const allProps: P = {
      ...props,
      ...injectedProps,
    } as unknown as P;

    return <Component {...allProps} />;
  };

  return EnhancedComponent;
}
